import React from 'react';
import {Link} from 'react-router-dom';


const FooterMenuItem = props => {
  const {title, url, onClick, withArrow, type} = props;
  return (
    <li className="footer-menu__item col-auto">
      {type === 'new' ?
        <a
          className="footer-menu__link"
          href={url}
          target="_blank"
          rel="no_follow"
          onClick={onClick}>
          {title}
        </a>
        : <Link
          className="footer-menu__link"
          to={url}
          onClick={onClick}>
          {title}
        </Link>}
    </li>
  );
}

const FooterMenu = props => {
  const {menuItems} = props;

  return (
    <nav className="footer-menu">
      <ul className="row footer-menu__list">
        {
          menuItems.map((menuItem, index) => {
            return (
              <FooterMenuItem
                type={menuItem.type}
                key={menuItem.title}
                title={menuItem.title}
                url={menuItem.url}
                index={index}
                withArrow={false}/>
            );
          })
        }
      </ul>
    </nav>
  );
}

export default FooterMenu;
